import {
  IconButton,
  IconDelete20,
} from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { CustomerBadge } from '@vend/react-utilities'
import { ApiCustomer } from '@vend/types'
import { LineItemFulfilmentCustomerHeaderView } from '../LineItemFulfilmentCustomerHeaderView'
import { LineItemFulfilmentCustomerContactView } from '../LineItemFulfilmentCustomerContactView'
import { PartialCustomerGroup } from '../../../../../react/modals/common/types'
import { useLineItemFulfilmentCustomerDetailsView } from './useLineItemFulfilmentCustomerDetailsView'

const TContext = 'Line item fulfilment popover'

export type LineItemFulfilmentCustomerDetailsViewProps = {
  onRemoveCustomer: () => void
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
  customer: ApiCustomer
  customerGroup?: PartialCustomerGroup
}
export const LineItemFulfilmentCustomerDetailsView: React.FC<LineItemFulfilmentCustomerDetailsViewProps> = ({
  onRemoveCustomer,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
  customer,
  customerGroup,
}: LineItemFulfilmentCustomerDetailsViewProps) => {
  const t = useT()
  const {
    handleRemoveCustomerMouseDown,
    handleRemoveCustomerClick,
  } = useLineItemFulfilmentCustomerDetailsView({
    onRemoveCustomer,
  })

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-6">
        <LineItemFulfilmentCustomerHeaderView />
        <div className="flex w-full flex-col gap-2">
          <span className="typography-body-sm-emphasized text-fg-neutral-default">
            {t('Customer', { _context: TContext })}
          </span>
          <div className="flex w-full min-w-0 items-start gap-2">
            <div className="min-w-0 flex-1">
              <CustomerBadge
                apiCustomer={customer}
                group={customerGroup}
                size="x-small"
              />
            </div>
            <span onMouseDown={handleRemoveCustomerMouseDown}>
              <IconButton
                appearance="danger-ghost"
                aria-label={t('Delete customer', { _context: TContext })}
                customDataAttributes={{
                  root: { 'data-track': 'remove-customer' },
                }}
                onClick={handleRemoveCustomerClick}
                size="small"
              >
                <IconDelete20 />
              </IconButton>
            </span>
          </div>
        </div>
        <LineItemFulfilmentCustomerContactView
          customer={customer}
          onEmailChange={onEmailChange}
          onPhoneNumberChange={onPhoneNumberChange}
          isEmailInvalid={isEmailInvalid}
        />
      </div>
    </div>
  )
}
